import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-catalog-suggestion-submitted-modal',
  templateUrl: './catalog-suggestion-submitted-modal.component.html',
  styleUrls: ['./catalog-suggestion-submitted-modal.component.scss'],
})
export class CatalogSuggestionSubmittedModalComponent {
  constructor(
    private dialogRef: MatDialogRef<CatalogSuggestionSubmittedModalComponent>,
  ) {}

  close = () => {
    this.dialogRef.close();
  }
}
